// PATH: src/pages/FAQ.jsx
// VERSION: 1.1 — Carga desde JSON
import React from 'react';
import {
  Box, Heading, Text, Accordion, AccordionItem, AccordionButton,
  AccordionPanel, AccordionIcon, Container, useColorModeValue
} from '@chakra-ui/react';
import faqs from '../data/faqs.json';

export default function FAQ() {
  const expandedBg = useColorModeValue('brand.100', 'whiteAlpha.200');

  return (
    <Box bg="bg.default" flex="1">
      <Container maxW="container.lg" py={{ base: 8, md: 10 }}>
        <Heading textAlign="center" mb={6} color="text.default">Preguntas Frecuentes</Heading>

        <Accordion allowToggle>
          {faqs.items.map((f, i) => (
            <AccordionItem key={i} bg="bg.card" border="1px solid" borderColor="border.default" borderRadius="md" mb={3}>
              <h2>
                <AccordionButton _expanded={{ bg: expandedBg }} borderRadius="md">
                  <Box as="span" flex="1" textAlign="left" fontWeight="semibold">
                    {f.q}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Text whiteSpace="pre-line">{f.a}</Text>
              </AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Container>
    </Box>
  );
}
